import { Link } from 'react-router-dom'

type SimpleLinkProps = {
    to: string
    children: React.ReactNode
    className?: string
}

export default function SimpleLink({ to, children, className }: SimpleLinkProps) {
    const baseClasses = 'font-semibold text-arwen-600 hover:text-arwen-700'
    const combinedClasses = className ? `${baseClasses} ${className}` : baseClasses

    return (
        <Link to={to} className={combinedClasses}>
            {children}
        </Link>
    )
}
